import { render, staticRenderFns } from "./ReservationTemplate.vue?vue&type=template&id=431c852c"
import script from "./ReservationTemplate.vue?vue&type=script&lang=js"
export * from "./ReservationTemplate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports